module.exports = __webpack_public_path__ + "static/media/splash.53297d2a.jpg";